import { Pipe, PipeTransform } from '@angular/core'

/**
 * Resolves a product's `imageUrl` down to the one image a thumbnail should show.
 *
 * The builder product shape carries the whole gallery in `imageUrl` so that the
 * edit form can round-trip it without dropping images. Everywhere that renders a
 * single thumbnail goes through this pipe instead of binding the raw value, which
 * would stringify an array into "url1,url2" and break the <img>.
 */
@Pipe({
  name: 'primaryImage',
})
export class PrimaryImagePipe implements PipeTransform {

  transform(value: string | string[] | null | undefined, fallback = 'assets/images/empty-image.png'): string {
    const first = Array.isArray(value) ? value[0] : value
    return first || fallback
  }

}
